import type { SessionContentsContextProps } from './session-contents-context';
import { sessionContentsContext } from './session-contents-context';

export interface SessionContentsContextProviderProps
  extends Omit<SessionContentsContextProps, 'staticSessionStore'> {
  children: React.ReactNode;
}

export const SessionContentsContextProvider = memo(function SessionContentsContextProvider({
  sessionStoreInstance,
  children,
  ...props
}: SessionContentsContextProviderProps) {
  const staticSessionStore = sessionStoreInstance.getState();
  const value = useMemo(() => {
    return { staticSessionStore, sessionStoreInstance, ...props };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staticSessionStore, sessionStoreInstance, ...Object.values(props)]);

  return (
    <sessionContentsContext.Provider value={value}>{children}</sessionContentsContext.Provider>
  );
});
